exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ai-chat-message {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  gap: 8px;\n}\n\n.content-container {\n  border-radius: 8px;\n  padding: 6px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n\n.content {\n  padding: 0px;\n  margin: 0px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.date {\n  font-size: 12px;\n  opacity: 0.70;\n  margin-top: -4px;\n  margin-bottom: -4px;\n}\n\n.user-message .content-container {\n  background-color: gainsboro;\n  text-align: right;\n}\n\n.assistant-message .content-container {\n  background-color: var(--primary);\n  color: white;\n}\n\n.actions-container {\n  margin-top: 4px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  gap: 4px;\n}\n\n::ng-deep a {\n  color: #ffffff;\n  font-weight: 500;\n  text-decoration: underline;\n  transition: opacity 0.2s ease, transform 0.1s ease;\n}\n\n::ng-deep a:hover {\n  opacity: 0.85;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/ai-chat/ai-chat-message/ai-chat-message.component.css
// module id = ../../../../../src/app/ai-chat/ai-chat-message/ai-chat-message.component.css
// module chunks = main